// @flow
import React from "react";
import CountUp from "react-countup";
import I18n from "../../../i18n/I18n";
import { Icon, LocaleLink } from "../";
import styles from "./PSkuUniqueBox.scss";

const PSkuUniqueBox = props => {
  const { total, pSku, getOfferCount, isOfferCounting } = props;
  const percent = pSku && total && total !== 0 ? pSku * 100 / total : 0;
  return (
    <div className={styles.pSkuUniqueBox}>
      <div className={styles.titleCtr}>
        <LocaleLink to={"/imports"}>
          <h4 className={styles.title}>
            {I18n.getText("side-menu.progression")}
          </h4>
        </LocaleLink>
        <div onClick={() => getOfferCount()}>
          <Icon name="loop" className={isOfferCounting ? styles.loading : ""} />
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={isOfferCounting ? styles.overlay : ""} />
        <div className={styles.barCtr}>
          <div
            className={styles.tag}
            style={{ marginLeft: `calc(${percent}% - 25px)` }}
          >
            <CountUp start={0} end={Number(percent)} decimals={2} />%
          </div>
          <div className={styles.progressBar}>
            <div className={styles.progress} style={{ width: `${percent}%` }} />
          </div>
        </div>
        <div>
          <div className={styles.pSkuCtr}>
            <div className={styles.label}>
              <h4>{I18n.getText("side-menu.offer-with")}</h4>
              <h3>{I18n.getText("side-menu.p-sku-unique")}</h3>
            </div>
            <div className={styles.pSkuCount}>{pSku}</div>
          </div>
          <div className={styles.total}>
            <div className={styles.label}>
              {I18n.getText("side-menu.total")}
            </div>
            <div className={styles.count}>{total}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PSkuUniqueBox;



// WEBPACK FOOTER //
// ./src/components/common/pSkuUniqueBox/PSkuUniqueBox.js